import {
  FormLocationTreeExtended,
  TFormLocationTreeExtended,
} from 'onboarding/components/widgets/public/forms/formLocationTreeExtended/FormLocationTreeExtended'

import { TAdaptingDisabled } from './types'

export const FormLocationTreeAdapter = ({
  disabled,
  isDisabled,
  ...props
}: TFormLocationTreeExtended & TAdaptingDisabled) => (
  <FormLocationTreeExtended {...props} isDisabled={isDisabled || disabled} />
)
